import { Component, computed, Input, OnDestroy, OnInit, signal, Signal, ViewChild, WritableSignal } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AttendeeInformation } from 'src/app/interfaces/interfaces';
import { AttendeesStore } from 'src/app/stores/attendees.store';

@Component({
  selector: 'app-add-attendee',
  templateUrl: './add-attendee.component.html',
  styleUrls: ['./add-attendee.component.scss'],
})
export class AddAttendeeComponent implements OnInit {
  @Input() initialAttendees: AttendeeInformation[] = [];
  @Input() startTime: string;
  @Input() endTime: string;
  @Input() bookingType: string;
  @Input() purpose: 'forward' | null = null;
  addedAttendees: WritableSignal<AttendeeInformation[]> = signal<AttendeeInformation[]>([]);
  searchTerm: WritableSignal<string> = signal('');
  attendeesList: Signal<AttendeeInformation[]> = computed(() => this.attendeesStore.attendees().filter(attendee => !this.addedAttendees().find(a => a.userPrincipalName === attendee.userPrincipalName) && this.attendeesStore.findAttendee(attendee,this.searchTerm())));


  constructor(
    private modalController: ModalController, 
    private attendeesStore: AttendeesStore
  ) {}

  ngOnInit() {
    if(this.bookingType === 'edit') {
      this.attendeesStore.checkAttendeeAvailability(this.initialAttendees.map(attendee => attendee.userPrincipalName),this.startTime, this.endTime).then(res => {
        this.initialAttendees.forEach(attendee => {
          attendee.isAvailable = res[attendee.userPrincipalName];
        });
      });
    }
    this.addedAttendees.set(this.initialAttendees);
  }


  async selectAttendee(attendee: AttendeeInformation) {
    attendee.isLoading = true
    try {
      const res = await this.attendeesStore.checkAttendeeAvailability([attendee.userPrincipalName], this.startTime, this.endTime)
      attendee.isAvailable = res[attendee.userPrincipalName];
      attendee.isLoading = false; 
      this.addedAttendees.update(attendees => [...attendees, attendee]);
    } catch (error) {
      attendee.isLoading = false; 
      console.error(error);
    }
  }

  makeOptional(attendee: AttendeeInformation) {
    this.addedAttendees.update(attendees => attendees.map(a => a.userPrincipalName === attendee.userPrincipalName ? { ...a, isOptional: true } : a));
  }

  removeAttendee(attendee: AttendeeInformation) {
    this.addedAttendees.update(attendees => attendees.filter(a => a.userPrincipalName !== attendee.userPrincipalName));
  }

  filterAttendees(event) {
    this.searchTerm.set(event.target.value);
  }

  isRemovableAttendee(attendee: any): boolean {
    return !(this.purpose === 'forward' && this.initialAttendees.some(a => a.userPrincipalName === attendee.userPrincipalName));
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  onDone() {
    this.modalController.dismiss(this.addedAttendees());
  }

}
